import React from 'react';

export default function PlatformFooter() {
  return (
    <div className="platform-footer" aria-label="Copyright notice">
      <span>&copy; 2026 RENOWN COMMODITY TRADING</span>
    </div>
  );
}
